module.exports = __webpack_public_path__ + "img/6.b6c4c483.jpg";